import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CaretDown } from "@phosphor-icons/react";
import { CircularProgress } from "../CircularProgress";
import { formatDate, filterTodosByDate, calculateProgress } from "@/lib/utils/todo";
import { TodoItem } from "@/types";
export interface TodoHeaderProps {
  selectedDate: Date;
  todos: TodoItem[];
  datesWithTodos: Set<string>;
  onDateChange: (date: Date) => void;
}
export function TodoHeader(t0) {
  const $ = _c(40);
  const {
    selectedDate,
    todos,
    datesWithTodos,
    onDateChange
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== selectedDate || $[1] !== todos) {
    const filtered = filterTodosByDate(todos, selectedDate);
    t1 = filtered;
    t2 = calculateProgress(filtered);
    t3 = filtered.filter(_temp).length;
    t4 = filtered.filter(_temp2);
    $[0] = selectedDate;
    $[1] = todos;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4.length) {
    t5 = {
      filteredTodos: t1,
      progress: t2,
      remainingCount: t3,
      completedCount: t4.length
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4.length;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const {
    progress,
    remainingCount,
    completedCount
  } = t5;
  let t6;
  if ($[11] !== selectedDate) {
    t6 = formatDate(selectedDate);
    $[11] = selectedDate;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CaretDown className="w-4 h-4 text-muted-foreground" />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6) {
    t8 = <PopoverTrigger asChild={true}><Button variant="ghost" className="!p-1 font-semibold text-2xl hover:no-underline flex items-center gap-1">{t6}{t7}</Button></PopoverTrigger>;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== onDateChange) {
    t9 = date => {
      if (date) {
        onDateChange(date);
      }
    };
    $[16] = onDateChange;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== datesWithTodos || $[19] !== selectedDate || $[20] !== t9) {
    t10 = <PopoverContent className="w-auto p-0" align="start"><Calendar mode="single" selected={selectedDate} onSelect={t9} datesWithTodos={datesWithTodos} initialFocus={true} /></PopoverContent>;
    $[18] = datesWithTodos;
    $[19] = selectedDate;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8) {
    t11 = <Popover>{t8}{t10}</Popover>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== progress) {
    t12 = <CircularProgress progress={progress} />;
    $[25] = progress;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12) {
    t13 = <div className="flex items-center justify-between">{t11}{t12}</div>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== remainingCount) {
    t14 = <span>{remainingCount} To Dos</span>;
    $[30] = remainingCount;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== completedCount) {
    t15 = completedCount > 0 && <><span className="text-muted-foreground/50">•</span><span className="text-muted-foreground/50">{completedCount} Completed</span></>;
    $[32] = completedCount;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t14 || $[35] !== t15) {
    t16 = <div className="!ml-1.5 text-sm text-muted-foreground flex items-center gap-1">{t14}{t15}</div>;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t13 || $[38] !== t16) {
    t17 = <div className="space-y-1">{t13}{t16}</div>;
    $[37] = t13;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
}
function _temp2(todo_0) {
  return todo_0.todo_item_status === "done";
}
function _temp(todo) {
  return todo.todo_item_status === "pending";
}